export default "__VITE_ASSET__CE$54xXt__"